import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesNote: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.432 4.575h1.52v25.9h-1.52Zm-1.53-1.53h1.53v1.53h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm1.518 6.09h-1.52V6.1h-1.52V4.575h-1.53v-1.53H3.052V32H25.9Zm-1.52 22.86H4.572v-25.9h13.71v6.09h6.1ZM4.572-.005h19.81v1.53H4.572Z\"/><path fill=\"currentColor\" d=\"M7.622 25.905h13.71v1.52H7.622Zm0-6.1h13.71v1.53H7.622Zm0-6.09h13.71v1.52H7.622Zm0-6.1h6.09v1.53h-6.09Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesNote
